/**
 * Cold Start Push Deeplink Handler (Web)
 *
 * No-op implementation - web doesn't have a cold start push concept.
 */

/**
 * Get the deeplink from a cold start push notification.
 * Always returns null on web.
 */
export function getInitialPushDeeplink(): Promise<string | null> {
  return Promise.resolve(null);
}
